import React, { useState } from "react";
import { usePassword } from "../shared/usePassword";
import "./PasswordScreen.scss";

const PasswordScreen: React.FC = (): JSX.Element => {
  const password = usePassword();
  const [current, setCurrent] = useState<string>();
  const [error, setError] = useState<boolean>(false);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    password.check(current);
    setError(!password.isAllowed());
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrent(event.target.value);
  };

  return (
    <div className="PasswordScreen">
      <header className="header">
        <i className="ui icon exclamation triangle massive"></i>
        <div className="ui input">
          <form onSubmit={handleSubmit}>
            <div className={`ui action input ${error ? "error" : ""}`}>
              <input
                type="text"
                placeholder="It's a secret..."
                onChange={handleChange}
              />
              <button className="ui button">Proceed</button>
            </div>
          </form>
        </div>
      </header>
    </div>
  );
};

export default PasswordScreen;
